<template>

<div v-if="dissave"  style="position:absolute; top: 300px;   width: 100%; z-index:100;  ">
  <Circle4 size="120px" class="mx-auto"></Circle4>
</div>




<div>
   <h2 class="text-center text-primary">Шумораи аҳолӣ</h2>
<!--
<p>
    <input type="button" value="Экспорт ба Excel" class="btn btn-primary" onclick="exportReportToExcel()" />
    <input type="button" value="Чопкунӣ" class="btn btn-primary" onclick="imprimir()" />
</p>
-->



<table class="table table-hover table-bordered table-striped" id="tabdata1">
    <thead>
        <tr>
            <th class="text-center">
                Минтақа
            </th>
            <th class="text-center">
                Ҳамагӣ
            </th>
            <th class="text-center">
                Мардҳо
            </th>
            <th class="text-center">
                Занҳо
            </th>
            <th width="170px"></th>
        </tr>
    </thead>
    <tbody>
       
            <tr v-for="r in list" :key="r">
                <td>
                    {{r.Name}}
                </td>
                <td>
                    {{r.c01}}
                </td>
                <td>
                    {{r.c02}}
                </td>
                <td>
                    {{r.c03}}
                </td>
<!--
                <td width="250px">
                    @if (item["ord"].ToInt() > 0   id == 0)
                    {
                        <a asp-action="index1" asp-route-id="@item[ ]" class="btn btn-primary mr-2">Гузариш</a>
                    }

                </td>
-->

            </tr>
         
    </tbody>
</table>
<!--
@if (id > 0)
{
    <p>
        <a asp-action="Index1" asp-route-id="0" class="btn btn-secondary">Бозгашт ба руйхат</a>
    </p>

}
-->
</div>
</template>



<script>
 

export default {

data(){

    return{
        list:'',
dissave:false,
        name:'',
        surname:''


    }
},

 methods:{

async GetReport(terid){

console.log('start report3');

this.dissave=true;

try{
                    await this.$api("/api/summary/"+1+"/"+terid+" /")
                  //  .then(res => res.json())
                    .then(data => this.list=data)
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop report3');
}
catch(ex){
console.log(ex);

}
finally{
console.log('finish');

}
this.dissave=false;
},

Spravka(h){
console.log(h);
 

this.$router.push('./spravka');

}

},

mounted(){

    this.GetReport(this.$store.state.terid);
}



}
</script>
